
import $ from "jquery";
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { Button, Grid, Dropdown, TextArea, Form, Input } from 'semantic-ui-react';
import Buttons from '@material-ui/core/Button';

import Loading from '../../loading';
import Server from '../../../functions/server';
import ReadCookie from '../../../functions/readcookies';


class ExpenseDetailss extends React.Component {

  state = {
    expenseDetails: [], maxWidth: 'sm', fullWidth: true, openAddExpence: false, toWhom: '', 
    paymentMode: [], selectedFromLedger: 'Mode', employeeDetails: [], expenseMaster: [], 
    customer: [], date: this.getFormatedDate(new Date()), purchaser: [], toSelectedCustomer: 0,
    toSelectedPurchaser: 0, toSelectedEmployee: 0, remarks: ''
  }

  componentDidMount() {
      this.getCurrentBranch();
      this.getExpense();
      this.getCustomer();
      this.getEmployee();
      this.getPaymentMode();
      this.getPurchaser();
  }


  getCurrentBranch() {
    let data = (ReadCookie("branch"));
    let branchId;
    for (var i = 0; i < data.length; i++) {
      branchId = data[i].branch_id;
    }
    this.setState({ currentBranch: branchId })
  }

  getPurchaser() {
    let context = this;
    context.setState({ load: true })
    $.ajax({
      type: 'POST',
      url: Server() + 'purchaser/getallpurchaser.php',
      success: function(data) {
        let purchaser = [];
        try {
          data = JSON.parse(data);
          data.map((c) => {
            purchaser.push({ key: c.name, text: c.name, value: c.id })
          })
          context.setState({ purchaser, load: false })
        } catch (e) {
          console.log(e);
          context.setState({ load: false })
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!')
      }
    });
  }

  getPaymentMode() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let data = (ReadCookie("branch"));
    let branch_id;
    for (var i = 0; i < data.length; i++) {
      branch_id = data[i].branch_id;
    }
    let userId = cook.id;
    context.setState({ load: true, message: 'Getting Paymentmode' })
    $.ajax({
      type: 'POST', data: { 'executiveid': userId, 'branchId': branch_id },
      url: Server() + 'modecontrol/getmode.php',
      success: function(data) {
        let paymentMode = [];
        try {
          data = JSON.parse(data);
          data.map((c) => {
            paymentMode.push({ text: c.mode, key: c.mode, value: c.id })
          })
          context.setState({ paymentMode, load: false })
        } catch (e) { context.setState({ load: false }); }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  getFormatedDate(dates) {
    let month = dates.getMonth() + 1; let date = dates.getDate();
    month = (month > 10) ? month : "0" + month;
    date = (date > 10) ? date : "0" + date;
    let x = dates.getFullYear() + "-" + month + "-" + date;
    return x;
  }

  getCustomer() {
    let context = this;
    context.setState({ load: true })
    $.ajax({
      type: 'POST',
      url: Server() + 'expensemaster/getcustomer.php',
      success: function(data) {
        let customer = [
            
        ];
        try {
          data = JSON.parse(data);
          data.map((c) => {
            customer.push({ key: c.id+'->'+c.name, text: c.id+'->'+c.name, value: c.id })
          })
          context.setState({ customer, load: false })
        } catch (e) {
          console.log(e);
          context.setState({ load: false })
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!')
      }
    });
  }

  getEmployee() {
    let context = this;
    $.ajax({
    type: 'POST',
    url: Server() + 'EmployeeDetails/get.php',
    success: function(data) {
        context.setState({ load: false, });
        let employeeDetails = [];
        try {
        data = JSON.parse(data);
        data.map((c) => {
            employeeDetails.push({ text: c.id+' -> '+c.name, key: c.id+' -> '+c.name, value: c.id })
        })
        context.setState({ employeeDetails })
        } catch (e) {
        alert('Error!!!');
        }
    },
    error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
    }
    });
  }

  getExpense() {
    let context = this;
    
    context.setState({ load: true })
    $.ajax({
      type: 'POST',
      url: Server() + 'expensemaster/get.php',
      success: function(data) {
        let expenseMaster = [];
        try {
          data = JSON.parse(data);
          data.map((c) => {
            expenseMaster.push({ key: c.name, text: c.name, value: c.id })
          })
          context.setState({ expenseMaster, load: false })
        } catch (e) {
          console.log(e);
          context.setState({ load: false })
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!')
      }
    });
  }


  dropdownSelect = (type) => (f, { value }) =>  {
    if (type == 'toSelectedCustomer') {
      this.setState({ [type]: value, toSelectedPurchaser: 0, toSelectedEmployee: 0 })
    }
    if (type == 'toSelectedPurchaser') {
      this.setState({ [type]: value, toSelectedEmployee: 0, toSelectedCustomer: 0 })
    }
    if (type == 'toSelectedEmployee') {
      this.setState({ [type]: value, toSelectedPurchaser: 0, toSelectedCustomer: 0 })
    }
    if (type == 'selectedToLedger') {
      this.setState({ [type]: value, toSelectedPurchaser: 0, toSelectedCustomer: 0, toSelectedEmployee: 0 })
    }
    if (type != 'selectedToLedger' || type != 'toSelectedEmployee' || type != 'toSelectedPurchaser' || type != 'toSelectedCustomer') {
      this.setState({ [type]: value })
    }
  }

  handleChange = (type) => (e, {value}) => {
    this.setState({ [type]: value }) 
  }

  submit() {
    let { toSelectedPurchaser, toSelectedEmployee, selectedFromLedger, selectedToLedger, fromSelectedMode, toSelectedCustomer, toSelectedExpense, currentBranch, amount, remarks, date } = this.state;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    let data = {};
    data = { toSelectedPurchaser, toSelectedEmployee, fromSelectedMode, toSelectedCustomer, toSelectedExpense, currentBranch, amount, remarks, userId, date };
    this.addModeToExpanse(data);
  }

  addModeToExpanse(data) {
    let context = this;
    context.setState({ load: true, message: 'adding expense!!!' })
    $.ajax({
      type: 'POST', data,
      url: Server() + 'expensedetail/modetoexpense.php',
      success: function(data) {
        
        if (data == 1) {
          alert('Saved')
          context.setState({ amount: '', remarks: '', openAddExpence: false, load: false })
          context.props.getAllExpense();
        }
        else {
          alert('Error')
          context.setState({ load: true })
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }


  clear() {
    this.setState({ amount: '', remarks: '', fromSelectedMode: 0, toSelectedPurchaser: 0, toSelectedEmployee: 0, toSelectedCustomer: 0, toSelectedExpense: 0, selectedToLedger: 0 })
  }
  

  render() {
      let toWhom1 = [
        // { key: 'Mode', text: 'Mode', value: 'Mode' },
        { key: 'Customer', text: 'Customer', value: 'Customer' },
        { key: 'Purchaser', text: 'Purchaser', value: 'Purchaser' },
        { key: 'Employee', text: 'Employee', value: 'Employee' },
        // { key: 'Branch', text: 'Branch', value: 'Expense' },
      ];

      let purchaser = this.state.purchaser;

      let fromOptionDropdown = (<div></div>);
      let toOptionDropdown = (<div></div>);
      if (this.state.selectedFromLedger == 'Customer') {
        fromOptionDropdown = (
            <div>
              Customer<br/>
              <Dropdown placeholder='Customers' style={{ borderColor: '#5A9CBB' }} search selection 
              onChange={this.dropdownSelect('fromSelectedCustomer')} fluid options={this.state.customer} 
              value={this.state.fromSelectedCustomer} />
            </div>
        );
      }
      if (this.state.selectedFromLedger == 'Employee') {
        fromOptionDropdown = (
            <div>
              Employee<br/>
              <Dropdown placeholder='Employee' style={{ borderColor: '#5A9CBB' }} 
              fluid search selection onChange={this.dropdownSelect('fromSelectedEmployee')}
              options={this.state.employeeDetails} value={this.state.fromSelectedEmployee} />
            </div>
        );
      }
      if (this.state.selectedFromLedger == 'Purchaser') {
        fromOptionDropdown = (
            <div>
              Purchaser<br/>
              <Dropdown placeholder='Purchaser' style={{ borderColor: '#5A9CBB' }}
              fluid search selection onChange={this.dropdownSelect('fromSelectedPurchaser')}
              options={purchaser} value={this.state.fromSelectedPurchaser} />
            </div>
        );
      }
      if (this.state.selectedFromLedger == 'Mode') {
        fromOptionDropdown = (
            <div>
              Payment Mode<br/>
              <Dropdown placeholder='Mode' style={{ borderColor: '#5A9CBB' }}
              fluid search selection onChange={this.dropdownSelect('fromSelectedMode')}
              options={this.state.paymentMode} value={this.state.fromSelectedMode} />
            </div>
        );
      }
      if (this.state.selectedFromLedger == 'Expense') {
        fromOptionDropdown = (
            <div>
              Expense<br/>
              <Dropdown placeholder='Expense' style={{ borderColor: '#5A9CBB' }}
              fluid search selection onChange={this.dropdownSelect('fromSelectedExpense')}
              options={this.state.expenseMaster} value={this.state.fromSelectedExpense} />
            </div>
        );
      }

      if (this.state.selectedToLedger == 'Customer') {
        toOptionDropdown = (
            <div>
              Customer<br/>
              <Dropdown placeholder='Customers' style={{ borderColor: '#5A9CBB' }}
              fluid search selection onChange={this.dropdownSelect('toSelectedCustomer')}
              options={this.state.customer} value={this.state.toSelectedCustomer} />
            </div>
        );
      }
      if (this.state.selectedToLedger == 'Employee') {
        toOptionDropdown = (
            <div>
              Employee<br/>
              <Dropdown placeholder='Employee' style={{ borderColor: '#5A9CBB' }}
                fluid search selection onChange={this.dropdownSelect('toSelectedEmployee')}
                options={this.state.employeeDetails} value={this.state.toSelectedEmployee} />
            </div>
        );
      }
      if (this.state.selectedToLedger == 'Purchaser') {
        toOptionDropdown = (
            <div>
              Purchaser<br/>
              <Dropdown placeholder='Purchaser' style={{ borderColor: '#5A9CBB' }}
              fluid search selection onChange={this.dropdownSelect('toSelectedPurchaser')}
              options={purchaser} value={this.state.toSelectedPurchaser} />
            </div>
        );
      }
      if (this.state.selectedToLedger == 'Mode') {
        toOptionDropdown = (
            <div>
              Payment Mode<br/>
              <Dropdown placeholder='Payment Mode' style={{ borderColor: '#5A9CBB' }}
              fluid search selection onChange={this.dropdownSelect('toSelectedMode')}
              options={this.state.paymentMode} value={this.state.toSelectedMode} />
            </div>
        );
      }

    return (
      <div>
        <Button onClick={ () => { this.setState({ openAddExpence: true }) }}>Add</Button>
        <Loading load={this.state.load} message={this.state.message} />
        <Dialog fullWidth={this.state.fullWidth}  maxWidth={this.state.maxWidth}
          open={this.state.openAddExpence} onClose={ () => { this.setState({ openAddExpence: false }) }} 
          aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Expense</DialogTitle>
          <DialogContent>
              <Grid>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                    Date<br/>
                    <input type="date" id="date" value={this.state.date}
                        style={{height: 35 }} onChange={ (event) => { this.setState({ date: event.target.value }) }} />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                    {fromOptionDropdown}
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  Expense<br/>
                  <Dropdown placeholder='Expense' style={{ borderColor: '#5A9CBB' }}
                  fluid search selection onChange={this.dropdownSelect('toSelectedExpense')}
                  options={this.state.expenseMaster} value={this.state.toSelectedExpense} />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                    Reference
                    <Dropdown placeholder='Reference' style={{ borderColor: '#5A9CBB' }}
                    fluid search selection onChange={this.dropdownSelect('selectedToLedger')} fluid
                    options={toWhom1} value={this.state.selectedToLedger} />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                    {toOptionDropdown}
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                    Amount<br/>
                    <Input fluid placeholder="Amount" value={this.state.amount} onChange={this.handleChange('amount')} />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                    Remarks<br/>
                    <Form>
                      <TextArea value={this.state.remarks} onChange={this.handleChange('remarks')} fluid />
                    </Form>
                </Grid.Column> 
              </Grid>
          </DialogContent>
          <DialogActions>
            <Buttons onClick={this.clear.bind(this)}>clear</Buttons>
            <Buttons onClick={ () => { this.setState({ openAddExpence: false }) }}>Close</Buttons>
            <Buttons onClick={this.submit.bind(this)}>Submit</Buttons>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default ExpenseDetailss;
